import { render, staticRenderFns } from "./SegmentResults.vue?vue&type=template&id=1b44ab2a&"
import script from "./SegmentResults.vue?vue&type=script&lang=js&"
export * from "./SegmentResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports